export class UpdateIdpGroupRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "roleIds",
            "baseName": "roleIds",
            "type": "Array<string>",
            "format": "uuid"
        },
        {
            "name": "displayName",
            "baseName": "displayName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateIdpGroupRequest.attributeTypeMap;
    }
    constructor() {
    }
}
